var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"popup-notification"},[_c('b-alert',{attrs:{"fade":"","variant":_vm.type,"show":_vm.show,"dismissible":""},domProps:{"textContent":_vm._s(_vm.message)},on:{"dismissed":_vm.dismissPopup}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }